module.exports = __webpack_public_path__ + "media/images/X-marks-the-spot-photo-21e14bfb.jpg";